<template>
<!--单卡充值-->
<section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="filters">
            <el-row>
                <el-col :span="10" style="text-align:left;">
                    <el-input v-model="filters.likeCardKey" placeholder="输卡号/ICCID/IMSI/查询码" style="width:100%;" clearable></el-input>
                </el-col>
                <el-col :span="4" style="padding-left:10px;text-align:left;">
                    <el-form-item>
                        <el-button type="primary" v-on:click="showCardDetail">&nbsp;&nbsp;&nbsp;&nbsp;查 询&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </el-col>
    <!--卡详情信息-->
    <template v-if="cardDetailVisible">
        <el-form label-width="100px" :model="cardDetail" ref="cardDetail">
            <div style="overflow: auto; width: 100%;">
                <table class="border-table">
                    <tr>
                        <td class="spec alt">卡号：</td>
                        <td>{{cardDetail.msisdn}}</td>
                        <td class="alt">ICCID:</td>
                        <td>{{cardDetail.iccid}}</td>
                        <td class="alt">IMSI:</td>
                        <td>{{cardDetail.imsi}}</td>
                    </tr>
                    <tr>
                        <td class="spec alt">用户状态：</td>
                        <td>{{cardDetail.cardstate}}</td>
                        <td class="alt">套餐名称：</td>
                        <td>{{cardDetail.packname}}</td>
                        <td class="alt">查询代码：</td>
                        <td>{{cardDetail.querycode}}</td>
                    </tr>
                    <tr>
                        <td class="spec alt">工作状态：</td>
                        <td>{{cardDetail.workstate}}</td>
                        <td class="alt">开机状态：</td>
                        <td>{{cardDetail.openstate}}</td>
                        <td class="alt">API代码：</td>
                        <td>{{cardDetail.apicode}}</td>
                    </tr>
                    <tr>
                        <td class="spec alt">是否签约短信服务：</td>
                        <td>{{cardDetail.smssign}}</td>
                        <td class="alt">是否签约GPRS:</td>
                        <td>{{cardDetail.gprssign}}</td>
                        <td class="alt">用户余额(元)：</td>
                        <td style="color:red;">{{formatCardBalance(cardDetail.balance)}}</td>
                    </tr>
                    <tr>
                        <td class="spec alt">套餐总流量：</td>
                        <td>{{formatGprsVal(cardDetail.gprstotal,'m')}}</td>
                        <td class="alt">已用流量：</td>
                        <td>{{formatGprsVal(cardDetail.gprsused)}}</td>
                        <td class="alt">剩余流量：</td>
                        <td>{{formatGprsVal(cardDetail.gprsnow)}}</td>
                    </tr>
                    <tr>
                        <td class="spec alt">当月短信使用条数：</td>
                        <td>{{cardDetail.smsmonthused}}</td>
                        <td class="alt">服务商名称：</td>
                        <td>{{cardDetail.servicername}}</td>
                        <td class="alt">激活时间：</td>
                        <td>{{cardDetail.activetime}}</td>
                    </tr>
                    <tr>
                        <td class="spec alt">APN：</td>
                        <td>{{cardDetail.apn}}</td>
                        <td class="alt">IP：</td>
                        <td>{{cardDetail.ip}}</td>
                        <td class="alt">接入类型：</td>
                        <td>{{cardDetail.innettype}}</td>
                    </tr>
                    <tr>
                        <td class="spec alt">入库日期：</td>
                        <td>{{cardDetail.inskutime}}</td>
                        <td class="alt">出库日期：</td>
                        <td>{{cardDetail.outskutime}}</td>
                        <td class="alt">最后更新时间：</td>
                        <td>{{cardDetail.lastsyntime}}</td>
                    </tr>
                    <tr>
                        <td class="spec alt">到期时间：</td>
                        <td>{{cardDetail.expiretime}}</td>
                        <td class="alt">开户时间：</td>
                        <td colspan="alt">{{cardDetail.openAccountTime}}</td>
                        <td class="alt">套餐金额(元)：</td>
                        <td style="color:red;">{{cardDetail.rechargePrice}}</td>
                    </tr>
                    <tr>
                        <td class="alt">备注信息：</td>
                        <td colspan="5">{{cardDetail.remark}}</td>
                    </tr>
                </table>
            </div>
        </el-form>

        <!--续费时长-->
        <el-row v-if="rechargeshow" class="toolbar" style="padding-bottom:0px;">
            <el-form :inline="true">
                <el-form-item label="续费时长：">
                    <el-select v-model="rechargemonth" @change="rechargemonthchange" placeholder="续费时长" style="width:300px;">
                        <el-option v-for="item in options_month" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </el-row>  

        <el-form v-if="rechargeshow" label-width="100px">
            <div style="overflow: auto; width: 100%;">
                <table class="border-table">
                    <tr>
                        <td class="spec alt">充值后到期时间：</td>
                        <td style="width:150px;">{{this.rechargeExpireTime}}</td>
                        <td class="alt">续费金额(元)：</td>
                        <td style="color:red;width:250px;font-weight:700;">￥{{this.finalrechargePrice}}</td>
                        <td class="alt"></td>
                        <td ></td>
                    </tr>
                </table>
            </div>
        </el-form> 
    </template>
    <template v-if="cardDetail.msisdn!=''">
        <div style="margin-top:20px;">
            <el-row>
                <el-col :span="12" style="text-align:left;">
                    <el-button type="primary" plain @click.native="updateCard" :loading="queryLoading">手动更新</el-button>
                </el-col>
                <el-col v-if="this.finalrechargePrice > 0" :span="12" style="text-align:right;">
                    <el-button type="success" icon="el-icon-money" @click="showRechargeQrcodeDialog">&nbsp;&nbsp;&nbsp;&nbsp;微信充值&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
                </el-col>
                <el-col v-else :span="12" style="text-align:right;">
                    <el-button type="success" icon="el-icon-money" disabled @click="showRechargeQrcodeDialog">&nbsp;&nbsp;&nbsp;&nbsp;微信充值&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
                </el-col>
            </el-row>
        </div>
    </template>
    <!--充值二维码-->
    <cardqrcode ref="cardqrcode"></cardqrcode>
</section>
</template>

<script>
import {
    getLikeOneCardDetail,
    getCardDetail,
    synCardDetail,
    getMoneyByMisidnAndMonth
} from '../../api/api';
import CardQrcode from '../../components/card_qrcode.vue';

export default {
    components: {
        cardqrcode: CardQrcode
    },
    data() {
        return {
            cardDetailVisible: true,
            queryLoading: false,
            rechargemonth: '12',
            options_month: [],
            finalrechargePrice: null,
            monthPrice: null,
            rechargeExpireTime: null,
            userid:null,
            filters: {
                likeCardKey: ''
            },
            cardDetail: {
                querycode: '',
                smssign: '',
                gprsused: '',
                gprssign: '',
                packname: '',
                openstate: '',
                smsmonthused: '',
                imsi: '',
                outskutime: '',
                gprsnow: '',
                activetime: '',
                iccid: '',
                balance: '',
                apicode: '',
                servicername: '',
                inskutime: '',
                msisdn: '',
                gprstotal: '',
                cardstate: '',
                lastsyntime: ''
            },
            rechargeshow: false,
        }
    },
    methods: {
        formatCardBalance(balance) {
            //如果余额小于0，则直接显示
            if (balance < 0) {
                return balance;
            } else {
                var user = sessionStorage.getItem('user');
                if (user) {
                    user = JSON.parse(user);
                    //如果是管理员角色，则显示余额
                    if (user.userlevel == 0) {
                        return balance;
                    }
                }
                return "";
            }
        },
        //格式化计算GPRS流量值
        formatGprsVal(arg, unit) {
            var gprs = parseFloat(arg);
            if (isNaN(gprs)) {
                return;
            }
            if (unit == 'm' || unit == 'M') {
                gprs = gprs * 1024;
            }
            var tmpRs = gprs / 1024;
            if (tmpRs < 1) {
                gprs = Math.round(gprs * 100) / 100;
                return gprs + "KB";
            }
            gprs = tmpRs;
            tmpRs = gprs / 1024;
            if (tmpRs < 1) {
                gprs = Math.round(gprs * 100) / 100;
                return gprs + "MB";
            }
            gprs = tmpRs;
            tmpRs = tmpRs / 1024;
            if (tmpRs < 1) {
                gprs = Math.round(gprs * 100) / 100;
                return gprs + "GB";
            }
        },
        updateCard() {
            console.log('准备访问接口更新卡的数据信息!');
            let para = {
                cardId: this.cardDetail.msisdn
            };
            this.queryLoading = true;
            synCardDetail(para).then((res) => {
                let {
                    msg,
                    code
                } = res;
                if (code !== 0) {
                    this.queryLoading = false;
                    this.$message({
                        message: msg,
                        type: 'error'
                    });
                } else {
                    getCardDetail(para).then((res) => {
                        this.queryLoading = false;
                        this.cardDetail = res.data;
                        this.rechargemonth = '12';
                        if(this.cardDetail.msisdn!=''){
                            this.rechargeshow = true;
                            this.finalrechargePrice = this.cardDetail.rechargePrice;
                            this.rechargeExpireTime = this.cardDetail.rechargeExpireTime;
                        }else{
                            this.rechargeshow = false;
                            this.finalrechargePrice = null;
                            this.rechargeExpireTime = null;
                        }
                        this.getMoneyByMisidnAndMonth();
                        this.$message({
                            message: "同步成功",
                            type: 'success'
                        });
                    });
                }
            });
        },
        showCardDetail() {
            //AJAX异步去数据库查询卡号详细信息
            if (this.filters.likeCardKey.trim() == '') {
                this.$message({
                    message: "请输入输卡号/ICCID/IMSI/查询码！",
                    type: 'error'
                });
                return;
            }
            let para = {
                likeCardKey: this.filters.likeCardKey.trim(),
                userid: this.userid
            };
            getLikeOneCardDetail(para).then((res) => {
                this.queryLoading = false;
                let {
                    msg,
                    code
                } = res;
                if (code !== 0) {
                    this.queryLoading = false;
                    this.$message({
                        message: msg,
                        type: 'error'
                    });
                } else {
                    if (res.data == undefined) {
                        this.$message({
                            message: "此物联网卡信息不存在,请检查是否输入错误！",
                            type: 'error'
                        });
                    } else {
                        this.cardDetail = res.data;
                        this.rechargemonth = '12';
                        if(this.cardDetail.msisdn!=''){
                            this.rechargeshow = true;
                            this.finalrechargePrice = this.cardDetail.rechargePrice;
                            this.rechargeExpireTime = this.cardDetail.rechargeExpireTime;
                        }else{
                            this.rechargeshow = false;
                            this.finalrechargePrice = null;
                            this.rechargeExpireTime = null;
                        }
                        this.getMoneyByMisidnAndMonth();
                    }
                }

            });
            this.cardDetailVisible = true;
        },
        showRechargeQrcodeDialog() {
            this.$refs.cardqrcode.showCardQrcodeWithMonth(this.cardDetail.iccid,this.rechargemonth);
        },
        getMoneyByMisidnAndMonth() {
            //根据卡号和续费时长查询续费金额
            let para = {
                likeCardKey: this.cardDetail.msisdn,
                rechargemonth: this.rechargemonth
            }
            getMoneyByMisidnAndMonth(para).then((res) => {
                this.finalrechargePrice = res.data.finalrechargePrice;
                this.rechargeExpireTime = res.data.rechargeExpireTime;
            });
        },
        rechargemonthchange(){
            if(this.cardDetail.msisdn != null && this.cardDetail.msisdn != ''){
                this.getMoneyByMisidnAndMonth();
            }
        }
    },
    mounted() {
        this.options_month = [];
        for(var i=1;i<=13;i++){
            let month = {
                "label": i + "个月",
                "value": i + ''
            }
            this.options_month.push(month);
        }
        let month_24 = {
            "label": "24个月",
            "value": '24'
        }
        this.options_month.push(month_24);
        let month_36 = {
            "label": "36个月",
            "value": '36'
        }
        this.options_month.push(month_36);

        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
            this.userid = user.userid;

        }
    }
}
</script>

<style scoped>
/* .el-row {
    margin-bottom: 0px;

    &:last-child {
        margin-bottom: 0;
    }
}

.el-col {
    border-radius: 0px;
    border: 1px solid #d3dce6;
} */

.bg-purple-dark {
    background: red;
}

.bg-purple {
    background: #FFF;
}

.bg-purple-light {
    color: #009966;
    min-height: 36px;
    line-height: 36px;
}

.grid-content {
    border-radius: 0px;
    border: 0px;
    min-height: 36px;
    line-height: 36px;
}

.row-bg {
    padding: 10px 0;
    background-color: red;
}

.border-table {
    border-collapse: collapse;
    border: none;
    width: 100%;
}

.border-table td {
    border: solid #dfe8ec 1px;
    background: #fff;
    font-size: 14px;
    padding: 6px 6px 6px 12px;
    color: #009966;
    line-height: 28px;
}

td.alt {
    background: #EFF2F7;
    color: #8492A6;
    width: 130px;
}
</style>



// WEBPACK FOOTER //
// rechargeCard.vue?f55dc834